
export const text = `The fourth item to be aware of is repeating segments of the video. You must always be precisely aware of how long a video is while watching it, or you may repeat entire segments without realizing it. Disable Youtube's loop feature, log out of your account, close your laptop, and stay with a relative for a minimum of five years. We have received your location.



`